import { render, staticRenderFns } from "./NanogenreTitles.vue?vue&type=template&id=5ebb6ccf&scoped=true&"
import script from "./NanogenreTitles.vue?vue&type=script&lang=js&"
export * from "./NanogenreTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb6ccf",
  null
  
)

export default component.exports